/**
 * This is a forked version of the NDS internal AutocompleteModalItem component,
 * which is used in the NDS AutocompleteModal.
 *
 * This particular file has no changes from the original
 * besides small differences in import paths, linting, or typing.
 */

const AutocompleteModalItem = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: string;
  /** Custom typeahead string. By default, typeahead uses `value`. */
  searchValue?: string;
}) => <>{children || value}</>;

AutocompleteModalItem.displayName = "Combobox.Item";

export default AutocompleteModalItem;
